module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_itr_r1.htm"
    }
  }, [_vm._v("Translator’s Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_prf_r1.htm"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c01_r1.htm"
    }
  }, [_vm._v("Why Read the Classics?")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c02_r1.htm"
    }
  }, [_vm._v("The Odysseys Within "), _c('em', [_vm._v("The Odyssey")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c03_r1.htm"
    }
  }, [_vm._v("Xenophon’s "), _c('em', [_vm._v("Anabasis")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c04_r1.htm"
    }
  }, [_vm._v("Ovid and Universal Contiguity")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c05_r1.htm"
    }
  }, [_vm._v("The Sky, Man, the Elephant")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c06_r1.htm"
    }
  }, [_vm._v("Nezami’s Seven Princesses")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c07_r1.htm"
    }
  }, [_vm._v("Tirant lo Blanc")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c08_r1.htm"
    }
  }, [_vm._v("The Structure of the "), _c('em', [_vm._v("Orlando Furioso")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c09_r1.htm"
    }
  }, [_vm._v("Brief Anthology of Octaves from Ariosto")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c10_r1.htm"
    }
  }, [_vm._v("Gerolamo Cardano")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c11_r1.htm"
    }
  }, [_vm._v("The Book of Nature in Galileo")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c12_r1.htm"
    }
  }, [_vm._v("Cyrano on the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c13_r1.htm"
    }
  }, [_c('em', [_vm._v("Robinson Crusoe")]), _vm._v(", Journal of Mercantile Virtues")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c14_r1.htm"
    }
  }, [_c('em', [_vm._v("Candide")]), _vm._v(", or Concerning Narrative Rapidity")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c15_r1.htm"
    }
  }, [_vm._v("Denis "), _c('em', [_vm._v("Diderot, Jacques le Fataliste")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c16_r1.htm"
    }
  }, [_vm._v("Giammaria Ortes")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c17_r1.htm"
    }
  }, [_vm._v("Knowledge as Dust-cloud in Stendhal")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c18_r1.htm"
    }
  }, [_vm._v("Guide for New Readers of Stendhal’s "), _c('em', [_vm._v("Charterhouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c19_r1.htm"
    }
  }, [_vm._v("The City as Novel in Balzac")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c20_r1.htm"
    }
  }, [_vm._v("Charles Dickens, "), _c('em', [_vm._v("Our Mutual Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c21_r1.htm"
    }
  }, [_vm._v("Gustave Flaubert, "), _c('em', [_vm._v("Trois Contes")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c22_r1.htm"
    }
  }, [_vm._v("Leo Tolstoy, "), _c('em', [_vm._v("Two Hussars")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c23_r1.htm"
    }
  }, [_vm._v("Mark Twain, "), _c('em', [_vm._v("The Man That Corrupted Hadleyburg")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c24_r1.htm"
    }
  }, [_vm._v("Henry James, "), _c('em', [_vm._v("Daisy Miller")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c25_r1.htm"
    }
  }, [_vm._v("Robert Louis Stevenson, "), _c('em', [_vm._v("The Pavilion on the Links")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c26_r1.htm"
    }
  }, [_vm._v("Conrad’s Captains")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c27_r1.htm"
    }
  }, [_vm._v("Pasternak and the Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c28_r1.htm"
    }
  }, [_vm._v("The World is an Artichoke")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c29_r1.htm"
    }
  }, [_vm._v("Carlo Emilio Gadda, the "), _c('em', [_vm._v("Pasticciaccio")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c30_r1.htm"
    }
  }, [_vm._v("Eugenio Montale, ‘Forse un mattino andando’")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c31_r1.htm"
    }
  }, [_vm._v("Montale’s Cliff")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c32_r1.htm"
    }
  }, [_vm._v("Hemingway and Ourselves")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c33_r1.htm"
    }
  }, [_vm._v("Francis Ponge")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c34_r1.htm"
    }
  }, [_vm._v("Jorge Luis Borges")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c35_r1.htm"
    }
  }, [_vm._v("The Philosophy of Raymond Queneau")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_c36_r1.htm"
    }
  }, [_vm._v("Pavese and Human Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_bm1_r1.htm"
    }
  }, [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/Calv_9780307549310_epub_ata_r1.htm"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-798cfd10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Calv_9780307549310_epub_toc_r1.vue
// module id = 66
// module chunks = 0